import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth } from "./lib/firebase";
import { useAuth } from "./Context/AuthContext";

export default function AuthFinish() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("Checking your login link...");
  const [email, setEmail] = useState("");
  const [needsEmailInput, setNeedsEmailInput] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user, accessToken } = useAuth();

  useEffect(() => {
    const checkLink = async () => {
      if (!isSignInWithEmailLink(auth, window.location.href)) {
        navigate("/");
        return;
      }

      const savedEmail = localStorage.getItem("emailForSignIn");
      if (savedEmail) {
        await completeSignIn(savedEmail);
      } else {
        // Ask user for email if not in localStorage
        setNeedsEmailInput(true);
        setIsLoading(false);
        setStatus("Enter your email to complete login");
      }
    };

    checkLink();
  }, [navigate]);

  const completeSignIn = async (emailToUse: string) => {
    try {
      setIsLoading(true);
      setStatus("Completing login...");
      await signInWithEmailLink(auth, emailToUse, window.location.href);
      localStorage.removeItem("emailForSignIn");
      setStatus("Signed in! Redirecting...");
    } catch (error) {
      console.error("Failed to complete login:", error);
      setStatus("❌ Failed to sign in. Please try again.");
      localStorage.removeItem("emailForSignIn");
      navigate("/");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    await completeSignIn(email);
  };

  useEffect(() => {
    if (status === "Signed in! Redirecting..." && user && accessToken) {
      navigate("/");
    }
  }, [ user, accessToken, navigate]);
      

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="p-6 bg-white rounded-lg shadow-lg text-center flex flex-col items-center gap-4 w-full max-w-sm">
        {isLoading && (
          <div className="w-8 h-8 border-4 border-gray-300 border-t-indigo-500 rounded-full animate-spin"></div>
        )}
        <p className="text-gray-700">{status}</p>

        {needsEmailInput && (
          <form onSubmit={handleSubmit} className="flex flex-col gap-3 w-full mt-4">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
            <button
              type="submit"
              className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isLoading}
            >
              Complete Login
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
